export const MOVIES = [
  {
    id: 1,
    title: "雾港迷踪",
    enTitle: "Mist Harbor",
    type: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 8.7,
    popularity: 98,
    updatedAt: "2025-10-12",
    duration: "128分钟",
    director: "陈牧",
    writer: "陈牧 / 顾行",
    language: "汉语普通话",
    status: "已上映",
    tagline: "雾散之前，没有人是无辜的。",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20film%20poster%20key%20art%20of%20a%20foggy%20harbor%20at%20night%2C%20lone%20detective%20silhouette%20in%20long%20coat%20standing%20on%20a%20wet%20stone%20pier%2C%20deep%20navy%20blue%20and%20warm%20amber%20dock%20lamp%20glow%2C%20soft%20film%20grain%2C%20dramatic%20mist%2C%20minimal%20negative%20space%2C%20no%20text%20no%20lettering&width=600&height=900&seq=hlwc-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20foggy%20harbor%20at%20night%20with%20wet%20stone%20pier%2C%20a%20lone%20figure%20in%20a%20long%20coat%20walking%20away%2C%20deep%20navy%20mist%20and%20amber%20dock%20lights%20reflecting%20on%20water%2C%20anamorphic%20film%20look%2C%20no%20text&width=1600&height=900&seq=hlwc-backdrop-01&orientation=landscape",
    synopsis: [
      "一座终年被雾笼罩的北方港口小城，连续三起失踪案在同一个雨夜被发现于废弃码头。负责调查的刑警沈砚回到故乡，却发现所有线索都指向二十年前那场被草草结案的沉船事故。",
      "随着调查深入，港口的老船主、沉默的灯塔看守人、以及沈砚少年时的好友逐一被卷入。每个人都守着一段不愿被提起的往事，而真相就藏在潮水退去后露出的那截锈蚀船锚之下。",
      "影片以冷峻的镜头语言铺陈一座正在衰败的港城，在悬疑推进之外，也写尽了人对故土与愧疚的复杂情感。",
    ],
    cast: [
      { actorId: 1, role: "沈砚" },
      { actorId: 2, role: "林漪" },
      { actorId: 3, role: "老周" },
      { actorId: 7, role: "陈默" },
    ],
    episodes: [],
    tags: ["雨夜追凶", "高智商对决", "港城群像"],
    featured: true,
  },
  {
    id: 2,
    title: "长夜将尽",
    enTitle: "Before the Long Night Ends",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "年代", "悬疑"],
    rating: 9.1,
    popularity: 95,
    updatedAt: "2025-10-08",
    duration: "全24集",
    director: "郑砚",
    writer: "郑砚 / 苏禾",
    language: "汉语普通话",
    status: "已完结",
    tagline: "灯亮着，就还有人等着回家。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20key%20art%20of%20an%20old%20Chinese%20alley%20at%20dusk%20in%20the%201990s%2C%20warm%20window%20lights%2C%20a%20woman%20standing%20in%20a%20doorway%2C%20deep%20navy%20shadows%20and%20amber%20glow%2C%20soft%20grain%2C%20restrained%20melancholy%20mood%2C%20no%20text%20no%20lettering&width=600&height=900&seq=hlwc-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20narrow%201990s%20Chinese%20alley%20at%20dusk%2C%20wet%20stone%20road%2C%20warm%20lanterns%20and%20blue%20evening%20haze%2C%20cinematic%20grain%2C%20no%20text&width=1600&height=900&seq=hlwc-backdrop-02&orientation=landscape",
    synopsis: [
      "1997 年冬天，纺织厂工人程远在下岗名单上看到了自己的名字。为了撑起一个正在散架的家，他开始在夜市摆摊，也在那一年遇见了刚从外地回来的苏禾。",
      "二十四集的篇幅里，两个普通人和他们周围的邻居一起，经历了工厂改制、南下打工、旧城改造。看似琐碎的日常之下，是一代人如何与时代和解的故事。",
      "剧集没有把苦难拍成奇观，而是把镜头留在饭桌、走廊与深夜的窗口，让「好好活着」成为最简单也最有力的答案。",
    ],
    cast: [
      { actorId: 4, role: "程远" },
      { actorId: 8, role: "苏禾" },
      { actorId: 1, role: "程父" },
      { actorId: 2, role: "何小满" },
    ],
    episodes: [
      { no: 1, title: "名单", duration: "45分钟", desc: "下岗名单贴出厂门，程远在人群后面站了很久。" },
      { no: 2, title: "夜市", duration: "47分钟", desc: "一辆二手三轮车，成了程家新的转折点。" },
      { no: 3, title: "回来的女孩", duration: "44分钟", desc: "苏禾带着一只旧皮箱回到巷子，没人知道她经历了什么。" },
      { no: 4, title: "第一场雪", duration: "46分钟", desc: "生意刚有起色，一场雪压塌了摊位的棚子。" },
      { no: 5, title: "借条", duration: "45分钟", desc: "程父瞒着家人向老同事借钱，被程远发现。" },
      { no: 6, title: "搬迁通知", duration: "48分钟", desc: "旧城改造的消息传来，整条巷子第一次坐在一起开会。" },
      { no: 7, title: "南下的火车", duration: "46分钟", desc: "何小满决定离开，站台上的送别没有一句多余的话。" },
      { no: 8, title: "长夜将尽", duration: "52分钟", desc: "灯重新亮起，程远在门口等到了那个熟悉的脚步声。" },
    ],
    tags: ["年代群像", "现实主义", "口碑佳作"],
    featured: true,
  },
  {
    id: 3,
    title: "星轨之上",
    enTitle: "Above the Orbit",
    type: "tv",
    year: 2025,
    region: "美国",
    genres: ["科幻", "冒险", "剧情"],
    rating: 8.4,
    popularity: 92,
    updatedAt: "2025-10-15",
    duration: "全10集",
    director: "亚历克斯·雷恩",
    writer: "米娅·科尔",
    language: "英语",
    status: "更新至第6集",
    tagline: "我们以为自己是被留下的那一批人。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20poster%20key%20art%20of%20a%20lone%20astronaut%20floating%20before%20a%20giant%20ringed%20planet%2C%20deep%20blue%20space%2C%20warm%20amber%20rim%20light%2C%20soft%20film%20grain%2C%20minimal%20composition%2C%20no%20text%20no%20lettering&width=600&height=900&seq=hlwc-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20vast%20ringed%20planet%20seen%20from%20a%20space%20station%20window%2C%20deep%20navy%20space%20with%20warm%20amber%20interior%20light%2C%20floating%20dust%20particles%2C%20anamorphic%20lens%2C%20no%20text&width=1600&height=900&seq=hlwc-backdrop-03&orientation=landscape",
    synopsis: [
      "近未来，一支国际空间站考察队在一次磁暴后与地面彻底失联。当他们重新建立联系，得到的却是来自四十年后的回应——地球上已经没有他们认识的人。",
      "指挥官凯恩与工程师伊芙必须决定：是尝试返航，还是继续执行那项没人能解释的任务。随着空间站深处一扇被封死的舱门被打开，他们发现这次任务从一开始就不是为了探索。",
      "剧集用封闭空间里的对话与沉默，讨论记忆、时间与人类是否值得被拯救这些并不轻松的命题。",
    ],
    cast: [
      { actorId: 5, role: "凯恩" },
      { actorId: 6, role: "伊芙" },
      { actorId: 3, role: "霍尔" },
    ],
    episodes: [
      { no: 1, title: "失联", duration: "52分钟", desc: "磁暴过后，通讯频道里只剩下白噪音。" },
      { no: 2, title: "四十年", duration: "50分钟", desc: "地面传来的第一句话，让整个指挥舱陷入沉默。" },
      { no: 3, title: "封死的舱门", duration: "49分钟", desc: "伊芙在结构图里找到一块不该存在的空白区域。" },
      { no: 4, title: "回声", duration: "51分钟", desc: "霍尔承认自己参加过上一批考察队的选拔。" },
      { no: 5, title: "氧气账本", duration: "48分钟", desc: "返航所需的氧气，只够两个人。" },
      { no: 6, title: "选择的重量", duration: "53分钟", desc: "凯恩在全员会议上第一次没有给出命令。" },
    ],
    tags: ["硬科幻", "太空悬疑", "年度期待"],
    featured: true,
  },
  {
    id: 4,
    title: "山海食记",
    enTitle: "Taste of the Mountains and Sea",
    type: "variety",
    year: 2025,
    region: "中国大陆",
    genres: ["美食", "纪实", "旅行"],
    rating: 8.9,
    popularity: 90,
    updatedAt: "2025-10-14",
    duration: "全12期",
    director: "周时雨",
    writer: "节目组",
    language: "汉语普通话",
    status: "更新至第9期",
    tagline: "一口热饭，就是一段归途。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20key%20art%20of%20a%20steaming%20bowl%20of%20noodles%20on%20a%20rustic%20wooden%20table%20at%20a%20mountain%20village%20dawn%2C%20warm%20amber%20light%2C%20misty%20green%20mountains%20behind%2C%20editorial%20food%20photography%2C%20no%20text%20no%20lettering&width=600&height=900&seq=hlwc-poster-04&orientation=portrait",
    synopsis: [
      "节目沿着中国漫长的高原与海岸线行走，从云南的山间集市到福建的渔村码头，寻找那些只在本地才吃得到的味道。",
      "主持人何叙不设脚本，只是坐下来和做菜的人聊天。一道腌菜、一锅汤、一条刚上岸的鱼，背后都是某个家庭几十年没有变过的生活节奏。",
      "第九期走进贵州苗寨，记录一场为外出务工者返乡而准备的团圆饭。",
    ],
    cast: [
      { actorId: 7, role: "主持人" },
      { actorId: 6, role: "常驻嘉宾" },
      { actorId: 5, role: "飞行嘉宾" },
    ],
    episodes: [
      { no: 1, title: "山里的第一口汤", duration: "48分钟", desc: "云南腾冲，一碗土锅子背后的三代人。" },
      { no: 2, title: "潮水退去之后", duration: "46分钟", desc: "福建东山岛，跟着渔民出海的一整天。" },
      { no: 3, title: "晒场上的秋天", duration: "45分钟", desc: "江西婺源，晒秋人家的辣椒与腊味。" },
      { no: 4, title: "一条街的早餐", duration: "47分钟", desc: "武汉清晨五点，热干面的第一锅水开了。" },
      { no: 5, title: "面案上的凌晨", duration: "44分钟", desc: "兰州牛肉面师傅的一天从半夜开始。" },
      { no: 6, title: "海风里的咸", duration: "46分钟", desc: "浙江渔村，用盐和时间保存一整个夏天。" },
      { no: 7, title: "高原上的火塘", duration: "49分钟", desc: "川西牧场，一锅酥油茶煮了三个小时。" },
      { no: 8, title: "巷子深处", duration: "45分钟", desc: "潮州老城，藏在骑楼下的卤味摊。" },
      { no: 9, title: "团圆饭", duration: "52分钟", desc: "贵州苗寨，为返乡的人准备的长桌宴。" },
    ],
    tags: ["治愈系", "在地风物", "人间烟火"],
  },
  {
    id: 5,
    title: "纸鸢与风",
    enTitle: "Kite and the Wind",
    type: "animation",
    year: 2023,
    region: "日本",
    genres: ["动画", "奇幻", "治愈"],
    rating: 8.8,
    popularity: 84,
    updatedAt: "2025-09-30",
    duration: "108分钟",
    director: "高濑优",
    writer: "高濑优",
    language: "日语",
    status: "已上映",
    tagline: "风记得每一只飞过的纸鸢。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20animated%20film%20poster%20key%20art%20of%20a%20paper%20kite%20flying%20over%20a%20watercolor%20countryside%2C%20warm%20sunset%20sky%20in%20amber%20and%20dusty%20blue%2C%20soft%20grain%2C%20gentle%20nostalgic%20mood%2C%20no%20text%20no%20lettering&width=600&height=900&seq=hlwc-poster-05&orientation=portrait",
    synopsis: [
      "海边小镇的女孩小鸢，每年春天都会把写给母亲的信绑在纸鸢上放走。她相信风会把信送到很远的地方。",
      "一个风特别大的午后，纸鸢带着她落进了一片只有旧物才会到达的原野。在那里，她遇见了修补记忆的旅人风见。",
      "两人一路收集被人遗忘的物件：生锈的钥匙、褪色的照片、没寄出的明信片。小鸢逐渐明白，告别不是把东西放下，而是学会带着它继续走。",
    ],
    cast: [
      { actorId: 8, role: "配音 · 小鸢" },
      { actorId: 2, role: "配音 · 风见" },
    ],
    episodes: [],
    tags: ["手绘质感", "成长", "治愈奇幻"],
  },
  {
    id: 6,
    title: "第九个春天",
    enTitle: "The Ninth Spring",
    type: "movie",
    year: 2024,
    region: "法国",
    genres: ["爱情", "剧情"],
    rating: 8.2,
    popularity: 76,
    updatedAt: "2025-09-22",
    duration: "112分钟",
    director: "艾米丽·杜兰",
    writer: "艾米丽·杜兰 / 苏晚",
    language: "法语",
    status: "已上映",
    tagline: "我们总是差一个春天。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20art%20house%20poster%20key%20art%20of%20a%20woman%20in%20a%20linen%20dress%20in%20a%20sunlit%20Paris%20courtyard%2C%20amber%20light%2C%20dusty%20blue%20shadows%2C%20soft%20film%20grain%2C%20quiet%20romantic%20mood%2C%20no%20text%20no%20lettering&width=600&height=900&seq=hlwc-poster-06&orientation=portrait",
    synopsis: [
      "巴黎近郊的一座小剧场里，舞台监督艾琳和灯光师卢卡连续八年错过彼此。每到春天，剧场都会短暂关闭，而他们总在不同的时间离开。",
      "第九年，剧场即将被出售。两人在最后一次装台时，翻出了八年来留下的工作笔记，上面写满了对方从不知道的关心。",
      "影片用几乎不动声色的方式讲述时间的重量：不是所有爱情都需要抵达，有些只需要被看见。",
    ],
    cast: [
      { actorId: 2, role: "艾琳" },
      { actorId: 5, role: "卢卡" },
    ],
    episodes: [],
    tags: ["法式浪漫", "剧场", "克制叙事"],
  },
  {
    id: 7,
    title: "逆流而上",
    enTitle: "Against the Current",
    type: "tv",
    year: 2024,
    region: "韩国",
    genres: ["剧情", "励志", "运动"],
    rating: 8.5,
    popularity: 88,
    updatedAt: "2025-10-05",
    duration: "全16集",
    director: "朴承贤",
    writer: "李度妍",
    language: "韩语",
    status: "已完结",
    tagline: "水不会为你让路，但你可以学会往前。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20key%20art%20of%20a%20determined%20young%20swimmer%20standing%20at%20the%20edge%20of%20an%20empty%20indoor%20pool%2C%20cold%20deep%20blue%20tones%20with%20warm%20amber%20highlight%2C%20soft%20film%20grain%2C%20dramatic%20silhouette%2C%20no%20text%20no%20lettering&width=600&height=900&seq=hlwc-poster-07&orientation=portrait",
    synopsis: [
      "姜河曾是全国最被看好的短距离自由泳选手，一次伤病让他离开了赛场，也离开了那座城市。五年后，他回到少年宫，成为一支快要解散的青少年游泳队的教练。",
      "队里最不服管教的女孩尹夏，有着和他当年一模一样的倔强。两人从互相看不顺眼，到一起站上区域赛的出发台。",
      "剧集没有把胜利当成终点，而是把重点放在每一次失败之后，如何重新走进水里。",
    ],
    cast: [
      { actorId: 4, role: "姜河" },
      { actorId: 8, role: "尹夏" },
      { actorId: 5, role: "崔敏浩" },
    ],
    episodes: [
      { no: 1, title: "回到水里", duration: "62分钟", desc: "姜河推开少年宫那扇生锈的铁门。" },
      { no: 2, title: "不服管教的女孩", duration: "60分钟", desc: "尹夏第一次在训练里赢过所有人。" },
      { no: 3, title: "旧伤", duration: "58分钟", desc: "一次突发抽筋，让姜河不得不面对自己的极限。" },
      { no: 4, title: "接力名单", duration: "61分钟", desc: "四个人，只有一个名额的争议。" },
      { no: 5, title: "出发台", duration: "59分钟", desc: "区域赛预赛，尹夏在起跳前看了教练一眼。" },
      { no: 6, title: "逆流而上", duration: "64分钟", desc: "决赛最后一棒，水花盖过了所有声音。" },
    ],
    tags: ["热血成长", "师徒关系", "运动题材"],
  },
  {
    id: 8,
    title: "深海回声",
    enTitle: "Echo from the Deep",
    type: "movie",
    year: 2025,
    region: "英国",
    genres: ["科幻", "惊悚", "悬疑"],
    rating: 8.0,
    popularity: 86,
    updatedAt: "2025-10-11",
    duration: "119分钟",
    director: "理查德·拜恩",
    writer: "诺拉·费恩",
    language: "英语",
    status: "已上映",
    tagline: "海沟之下，有东西在回应我们。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20thriller%20poster%20key%20art%20of%20a%20deep%20sea%20research%20submarine%20window%20with%20faint%20bioluminescent%20light%2C%20dark%20navy%20water%2C%20single%20warm%20amber%20lamp%2C%20soft%20film%20grain%2C%20tense%20atmosphere%2C%20no%20text%20no%20lettering&width=600&height=900&seq=hlwc-poster-08&orientation=portrait",
    synopsis: [
      "一支深海科考队在马里亚纳海沟布设声呐阵列时，收到了一段规律得不像自然产生的回声。它每三十七分钟出现一次，而且每次都比上一次更近。",
      "生物学家诺拉坚持继续下潜，领队埃利奥特则想立刻上浮。当潜艇的通讯与动力相继失效，他们才发现，真正难以判断的不是海底有什么，而是谁在说谎。",
      "影片几乎全部发生在狭窄的舱室内，用光线与声音制造压迫感，是一次对未知与恐惧的克制探索。",
    ],
    cast: [
      { actorId: 6, role: "诺拉" },
      { actorId: 1, role: "埃利奥特" },
      { actorId: 3, role: "船长米勒" },
    ],
    episodes: [],
    tags: ["深海恐惧", "密闭空间", "声音设计"],
  },
  {
    id: 9,
    title: "胡同里的烟火",
    enTitle: "Fireworks in the Hutong",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["家庭", "生活", "喜剧"],
    rating: 8.6,
    popularity: 81,
    updatedAt: "2025-09-18",
    duration: "全32集",
    director: "刘一鸣",
    writer: "刘一鸣 / 何叙",
    language: "汉语普通话",
    status: "已完结",
    tagline: "一条胡同，装得下所有鸡毛蒜皮。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20key%20art%20of%20a%20Beijing%20hutong%20courtyard%20in%20winter%2C%20red%20lanterns%20and%20warm%20kitchen%20light%2C%20steam%20rising%20from%20a%20pot%2C%20soft%20grain%2C%20cozy%20nostalgic%20mood%2C%20no%20text%20no%20lettering&width=600&height=900&seq=hlwc-poster-09&orientation=portrait",
    synopsis: [
      "老赵在胡同口开了三十年早点铺，一张桌子、两口锅、三句闲话，撑起了整条街的早晨。拆迁消息传来，他的铺子正好在规划红线里。",
      "女儿赵小满从外地回来劝他搬走，父女俩为一张老木桌吵了整整一个夏天。邻居们各有各的算盘，也各有各的不舍。",
      "没有大起大落的冲突，全是生活里真实发生过的小事。看完会想给家里打个电话的那种剧。",
    ],
    cast: [
      { actorId: 7, role: "老赵" },
      { actorId: 8, role: "赵小满" },
      { actorId: 2, role: "林小雅" },
    ],
    episodes: [
      { no: 1, title: "早点铺", duration: "44分钟", desc: "凌晨四点，老赵的第一锅豆浆开了。" },
      { no: 2, title: "红线", duration: "43分钟", desc: "一张规划图贴在了胡同口。" },
      { no: 3, title: "女儿回来了", duration: "45分钟", desc: "赵小满拖着行李箱站在铺子门口。" },
      { no: 4, title: "那张老木桌", duration: "44分钟", desc: "一张桌子，两代人的坚持。" },
      { no: 5, title: "邻里会", duration: "46分钟", desc: "全院第一次为同一件事坐到一起。" },
      { no: 6, title: "最后一碗", duration: "48分钟", desc: "铺子关门前，老赵给每个熟客都多加了一个鸡蛋。" },
    ],
    tags: ["京味生活", "家庭群像", "下饭剧"],
  },
  {
    id: 10,
    title: "夏日放映厅",
    enTitle: "Summer Screening Room",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["访谈", "文化", "电影"],
    rating: 8.3,
    popularity: 72,
    updatedAt: "2025-09-26",
    duration: "全10期",
    director: "林间",
    writer: "节目组",
    language: "汉语普通话",
    status: "已完结",
    tagline: "一部电影，一个愿意说真话的夜晚。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20key%20art%20of%20an%20open%20air%20cinema%20under%20a%20summer%20night%20sky%2C%20glowing%20screen%20and%20scattered%20audience%20silhouettes%2C%20warm%20amber%20projector%20light%20with%20deep%20blue%20dusk%2C%20no%20text%20no%20lettering&width=600&height=900&seq=hlwc-poster-10&orientation=portrait",
    synopsis: [
      "每期节目选一部对嘉宾意义特殊的电影，在一间布置成老式放映厅的录影棚里重看，然后聊到凌晨。",
      "没有提词器，也不规定问题顺序。导演、演员、编剧在这里说的是创作时真正卡住的地方，而不是宣传期该说的话。",
      "第十期邀请苏晚与林知远重看《雾港迷踪》，聊到了那场拍了十七遍的雨夜戏。",
    ],
    cast: [
      { actorId: 3, role: "主持人" },
      { actorId: 2, role: "常驻嘉宾" },
      { actorId: 1, role: "飞行嘉宾" },
    ],
    episodes: [
      { no: 1, title: "重看一部旧片", duration: "58分钟", desc: "开场，三个人坐在空荡荡的放映厅里。" },
      { no: 2, title: "导演的第一次", duration: "56分钟", desc: "关于处女作，以及那些不敢回看的镜头。" },
      { no: 3, title: "演员的功课", duration: "57分钟", desc: "一个角色是从什么时候开始变成自己的。" },
      { no: 4, title: "雨夜十七遍", duration: "60分钟", desc: "《雾港迷踪》那场戏的完整幕后。" },
      { no: 5, title: "写不出来的第三幕", duration: "55分钟", desc: "编剧聊创作中最难堪的时刻。" },
      { no: 6, title: "散场之后", duration: "62分钟", desc: "最后一期，聊观众与电影的关系。" },
    ],
    tags: ["深度访谈", "电影文化", "深夜节目"],
  },
  {
    id: 11,
    title: "雪线以南",
    enTitle: "South of the Snowline",
    type: "movie",
    year: 2022,
    region: "中国大陆",
    genres: ["冒险", "剧情", "灾难"],
    rating: 8.1,
    popularity: 68,
    updatedAt: "2025-08-30",
    duration: "134分钟",
    director: "高原",
    writer: "高原 / 江野",
    language: "汉语普通话",
    status: "已上映",
    tagline: "山不会记得我们，但我们会记得山。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20adventure%20poster%20key%20art%20of%20a%20snow%20mountain%20ridge%20at%20dawn%2C%20two%20tiny%20climber%20silhouettes%2C%20cold%20blue%20shadow%20with%20warm%20amber%20sunrise%20edge%2C%20soft%20film%20grain%2C%20no%20text%20no%20lettering&width=600&height=900&seq=hlwc-poster-11&orientation=portrait",
    synopsis: [
      "一支民间登山队在雨季结束前进入无人区，目标是完成一条从未有人登顶的西南壁路线。队长江衡清楚这次窗口期只有三天。",
      "队员洛桑是当地向导，他一路都在劝队伍折返，因为山里的风向不对。第三天夜里，突发的雪崩切断了他们唯一的退路。",
      "影片用大量实景拍摄还原高海拔的压迫感，也在极端环境中追问：登顶到底是为了证明什么。",
    ],
    cast: [
      { actorId: 5, role: "洛桑" },
      { actorId: 4, role: "周衡" },
      { actorId: 1, role: "老韩" },
    ],
    episodes: [],
    tags: ["高海拔", "实景拍摄", "人性抉择"],
  },
  {
    id: 12,
    title: "云端旅店",
    enTitle: "Hotel Above the Clouds",
    type: "animation",
    year: 2025,
    region: "中国大陆",
    genres: ["动画", "奇幻", "治愈"],
    rating: 8.9,
    popularity: 89,
    updatedAt: "2025-10-16",
    duration: "全26集",
    director: "汪一舟",
    writer: "汪一舟 / 温以宁",
    language: "汉语普通话",
    status: "更新至第18集",
    tagline: "每一位旅客，都带着一朵云。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20animated%20poster%20key%20art%20of%20a%20tiny%20floating%20hotel%20above%20a%20sea%20of%20clouds%20at%20sunset%2C%20warm%20amber%20and%20soft%20dusty%20blue%20palette%2C%20whimsical%20gentle%20style%2C%20no%20text%20no%20lettering&width=600&height=900&seq=hlwc-poster-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20small%20floating%20hotel%20drifting%20above%20a%20sea%20of%20clouds%20at%20golden%20sunset%2C%20warm%20amber%20light%20and%20dusty%20blue%20sky%2C%20painterly%20whimsical%20style%2C%20no%20text&width=1600&height=900&seq=hlwc-backdrop-12&orientation=landscape",
    synopsis: [
      "在云层之上，有一间只在黄昏出现的旅店。老板娘阿云负责接待那些走得太远、暂时不想回家的人。",
      "每位旅客入住时都要交出一朵云，那是他们最想留住的记忆。老旅店长则负责把这些云收进阁楼的玻璃罐里。",
      "单元剧的形式，一集一个旅客的故事。有人在等一封永远不会到的信，有人只想再听一次母亲唱的歌。看完会安静很久的那种作品。",
    ],
    cast: [
      { actorId: 6, role: "配音 · 阿云" },
      { actorId: 7, role: "配音 · 老旅店长" },
      { actorId: 8, role: "配音 · 小满" },
    ],
    episodes: [
      { no: 1, title: "黄昏开门", duration: "22分钟", desc: "云海翻涌，旅店的灯亮了。" },
      { no: 2, title: "会唱歌的玻璃罐", duration: "21分钟", desc: "一位旅客想找回母亲唱过的摇篮曲。" },
      { no: 3, title: "没寄出的信", duration: "23分钟", desc: "邮差在旅店住了下来，等一个收信人。" },
      { no: 4, title: "住在雨里的人", duration: "22分钟", desc: "他的云一直在下雨，阿云决定不撑伞。" },
      { no: 5, title: "十二岁的夏天", duration: "21分钟", desc: "一个男孩想留在云上，不回地面。" },
      { no: 6, title: "旅店的名字", duration: "24分钟", desc: "老旅店长讲起旅店最初的样子。" },
    ],
    tags: ["单元故事", "国创动画", "温柔治愈"],
    featured: true,
  },
];